import { axiosInstance } from "./apiClient";

export const CATEGORIES = [
  "RETAIL",
  "INFRASTRUTTURE",
  "INDUSTRIALE",
  "FTV",
  "TFM",
  "HOTEL",
  "SANITARIO",
  "RESIDENZIALE",
] as const;

export type Category = typeof CATEGORIES[number];

export const DISCIPLINES = ["ELE", "MEC"] as const;
export type Discipline = typeof DISCIPLINES[number];

export const configApi = {
  getCategories: async (): Promise<{ categories: string[]; disciplines: string[] }> => {
    const res = await axiosInstance.get("/config/categories");
    return res.data;
  },
};
